import { setWsRequestData } from "../../services/slices/appConfig";
import {
  generateDemoPDF,
  // generatedTimestamp,
} from "../../Components/AddElementPanel2/Components/WidgetSelectors/CanvasPanel/utils/generateBunkeringPDF";
import { takeBunkeringData } from "../../Components/AddElementPanel2/Components/WidgetSelectors/CanvasPanel/PanelEditor/hooks/useBunkering";
import { sendCommand } from "../../api/Command/set.state";
import notify from "../Notification/notify";
import { toast } from "react-toastify";

// const REPORT_CHUNK_SIZE = 110;

/* UPDATE OPERATION SOURCES */
export const updateOperationSources = (
  dispatch,
  pdfSettings,
  wsRequestData
) => {
  if (!Array.isArray(pdfSettings)) return;

  const opSources = {};
  const timestampTags = {};

  const pushUnique = (table, ship, value) => {
    if (!ship || !value) return;
    if (!table[ship]) table[ship] = [];
    if (!table[ship].includes(value)) table[ship].push(value);
  };

  pdfSettings.forEach((pdf) => {
    pushUnique(opSources, pdf?.triggerTag?.ship, pdf?.triggerTag?.value);
    pushUnique(timestampTags, pdf?.startTsTag?.ship, pdf?.startTsTag?.value);
    pushUnique(timestampTags, pdf?.endTsTag?.ship, pdf?.endTsTag?.value);
  });

  const prev = wsRequestData?.operationSources ?? {};
  const prevTs = wsRequestData?.operationTimestampTags ?? {};
  if (
    JSON.stringify(prev) !== JSON.stringify(opSources) ||
    JSON.stringify(prevTs) !== JSON.stringify(timestampTags)
  ) {
    dispatch(
      setWsRequestData({
        operationSources: opSources,
        operationTimestampTags: timestampTags,
      })
    );
  }
};

/* MAP ROWS -> INJECT VALUES */
export const mapRowsToLatestRecord = (rows, latestRecord) => {
  if (!Array.isArray(rows) || !latestRecord)
    return Array.isArray(rows) ? rows : [];

  return rows.map((r) => {
    const key = r?.tag?.value;
    console.log("Mapping row:", r, " key:", key);

    const isBold = r?.isBold;
    if (!key || typeof key !== "string") return r;
    const val = latestRecord[key];
    if (val === undefined || val === null) return r;
    const finalValue = val === "" ? "--" : val;
    return { ...r, value: finalValue, isBold };
  });
};

export const mapBarChartToLatestRecord = (barChart, latestRecord) => {
  if (!Array.isArray(barChart) || !latestRecord)
    return Array.isArray(barChart) ? barChart : [];
  return barChart.map((b) => {
    const key = b?.value;
    if (!key || typeof key !== "string") return b;
    const val = latestRecord[key];
    if (val === undefined || val === null) return b;
    const finalValue = val === "" ? null : val;
    return { ...b, finalValue };
  });
};

/* FETCH BUNKERING DATA */
export const receivebunkeringData = async (data = {}) => {
  const { ship, start, end, averageTags = [], latestTags = [], title, prologue, epilogue, emails, metadata } = data || {};

  if (!ship) return null;

  const startObj = start
    ? new Date(String(start).replace(" ", "T") + "Z")
    : null;
  const endObj =
    end && !isNaN(new Date(String(end).replace(" ", "T") + "Z"))
      ? new Date(String(end).replace(" ", "T") + "Z")
      : new Date();
  if (!startObj || isNaN(startObj)) return null;

  try {
    const response = await takeBunkeringData({
      ship,

      start: startObj.toISOString(),
      end: endObj.toISOString(),

      averageTags,
      latestTags,

      title,

      emails,

      metadata
    });
    return { ...response };
  } catch (e) {
    return console.error("Error in receivebunkeringData:", e);
  }
};

/* HANDLE BUNKERING -> PDF */
export const handleBunkeringAndPdf = async ({
  ship,
  start,
  end,
  latestTags,
  resetTagValue,
  title,
  prologue,
  epilogue,
  rows,
  emails,
  plc,
  barChart,
}) => {
  const toastId = notify("Generating PDF...", "loading");

  console.log("handleBunkeringAndPdf barChart", barChart)

  const metadata = { rows, barChart, prologue, epilogue }

  try {
    const resp = await receivebunkeringData({
      ship,

      start,
      end,

      averageTags: [],
      latestTags,

      title,

      emails,

      metadata
    });
    console.log(resp, " bunkering data for PDF");

    if (!resp) throw new Error("No bunkering data received");

    if (resetTagValue) {
      sendCommand(0, resetTagValue, ship, false);
    }

    const rowValues = mapRowsToLatestRecord(rows || [], resp?.latestRecord);
    console.log("Row values for PDF:", rowValues, rows);
    const mappedBarChart = mapBarChartToLatestRecord(
      barChart || [],
      resp?.latestRecord
    );

    // const gTs = generatedTimestamp();

    const pdfOut = await generateDemoPDF({
      headerTimestamp: end,
      rows: rowValues,
      title: title || "",
      prologue: prologue || "",
      epilogue: epilogue || "",
      returnDataUri: true,
      barChart: mappedBarChart,
    });

    const dataUri = pdfOut?.dataUri || null;
    const pdfFileName =
      pdfOut?.fileName ||
      `${title ? title.replace(/[^a-zA-Z0-9-_]/g, "_") : "report"}.pdf`;
    const pdfBase64 = dataUri ? String(dataUri).split(",")[1] : null;

    // const reportStr = buildOperationReportString({
    //   title: title || "Operation Report",
    //   ts: end,
    //   gTs: gTs,
    //   rowValues,
    //   prologue: prologue || "",
    //   epilogue: epilogue || "",
    // });
    // console.log(reportStr, "reeportstr");
    // const b64All =
    //   typeof btoa === "function"
    //     ? btoa(unescape(encodeURIComponent(reportStr)))
    //     : Buffer.from(reportStr, "utf8").toString("base64");
    // const chunkCount = Math.ceil((b64All.length || 0) / REPORT_CHUNK_SIZE);

    // const headerId = sendReportHeaderS1({
    //   ship,
    //   title: title || "Report",
    //   ts: end,
    //   gTs,
    //   rowCount: rowValues.length,
    //   chunkCount,
    //   emails,
    //   plc,
    // });
    // console.log(plc, "plc1");
    // toast.dismiss(toastId);
    // notify("Saving PDF...", "loading");

    // await sendReportInChunks({ ship, id: headerId, b64: b64All, plc });

    // await wait(2000);
    // toast.dismiss(toastId);
    // notify("PDF generated successfully!", "success");

    if (Array.isArray(emails) && emails.length > 0 && pdfBase64) {
      try {
        toast.dismiss(toastId);
        await sendPdfEmail({
          ship,
          emails,
          subject: title || pdfFileName,
          body: `Please find attached the generated PDF: ${pdfFileName}`,
          filename: pdfFileName,
          base64: pdfBase64,
        });
        notify("Emails sent successfully!", "success");
      } catch (_) {
        notify("Email sending failed", "error");
      }
    }
  } catch (err) {
    console.error("Error generating PDF:", err);
    toast.dismiss(toastId);
    notify(
      "Failed to generate PDF. Check PDF's timestamps or call admin.",
      "error"
    );
  }
};

/* BUILD OPERATION REPORT STRING */
// function buildOperationReportString({
//   title,
//   ts,
//   gTs,
//   rowValues,
//   prologue,
//   epilogue,
// }) {
//   const r = (Array.isArray(rowValues) ? rowValues : []).map((row) => {
//     const label =
//       (row?.name && String(row.name).trim()) ||
//       row?.tag?.label ||
//       row?.tag?.value ||
//       "-";

//     const isTime = row?.unit === "startTs" || row?.unit === "endTs";
//     let val = row?.value;

//     if (val == null || val === "" || val === "NaN") {
//       val = "--";
//     } else if (!isTime && typeof val !== "number") {
//       const num = Number(val);
//       if (Number.isFinite(num) && Math.abs(num) < 1e12) val = num;
//       else val = String(val);
//     } else if (isTime) {
//       val = String(val);
//     }

//     const unit = row?.unit;
//     const isBold = row?.isBold;
//     if (!unit && !isBold) return [label, val];
//     return [label, val, unit, isBold];
//   });

//   const payload = {
//     t: title || "Report",
//     ts,
//     gTs,
//     r,
//     prologue: prologue ?? "",
//     epilogue: epilogue ?? "",
//   };
//   return JSON.stringify(payload);
// }

/* WAIT */
// function wait(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

export async function sendPdfEmail({
  ship,
  emails,
  subject,
  body,
  filename,
  base64,
}) {
  console.log("Sending PDF email to:", emails, subject, filename);
  if (!Array.isArray(emails) || emails.length === 0 || !base64) return;
  const payload = {
    to: emails,
    subject,
    body,
    pdf: { filename, base64 },
  };
  sendCommand(payload, "EMAIL_MANAGER_CMD", ship);
}

/* SEND REPORT IN CHUNKS */
// async function sendReportInChunks({
//   ship,
//   startIndex = 2,
//   text,
//   b64,
//   id,
//   plc,
// }) {
//   const baseTag = `${plc}_PDF_REPORT_S`;
//   const CHUNK = REPORT_CHUNK_SIZE;
//   const b64All =
//     typeof b64 === "string" && b64.length
//       ? b64
//       : typeof btoa === "function"
//       ? btoa(unescape(encodeURIComponent(text || "")))
//       : Buffer.from(text || "", "utf8").toString("base64");

//   let i = 0;
//   let part = startIndex;
//   while (i < b64All.length) {
//     const bSeg = b64All.slice(i, i + CHUNK);
//     const tagName = `${baseTag}${part}`;
//     await wait(3500);
//     const payload = JSON.stringify({ i: id, b: bSeg });
//     sendCommand(payload, tagName, ship);
//     i += CHUNK;
//     part += 1;
//   }
// }

/* SEND REPORT HEADER S1 */
// function sendReportHeaderS1({
//   ship,
//   title,
//   ts,
//   gTs,
//   rowCount,
//   chunkCount,
//   emails,
//   plc,
// }) {
//   const id = Math.random().toString(36).substring(2, 8);

//   const headerObj = {
//     v: 3,
//     id,
//     t: title || "Report",
//     ts,
//     gTs,
//     n: rowCount ?? 0,
//     S: Number.isFinite(chunkCount) && chunkCount > 0 ? chunkCount : 0,
//     e: Array.isArray(emails) ? emails : [],
//   };

//   const str = JSON.stringify(headerObj);

//   sendCommand(str, `${plc}_PDF_REPORT_S1`, ship);
//   return id;
// }

/* GET LOCAL START END */
export function getLocalStartEnd(tsValue, offsetMinutes = 2) {
  if (!tsValue) return { start: null, end: null };

  const [hours, minutes] = tsValue.split(":").map(Number);
  const now = new Date();

  const endDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes,
    0
  );
  const startDate = new Date(endDate.getTime() - offsetMinutes * 60 * 1000);

  const toLocalString = (d) => d.toLocaleString("sv-SE").replace(" ", "T");

  return { start: toLocalString(startDate), end: toLocalString(endDate) };
}

/* GET LOCAL START END FOR DATE */
export function getLocalStartEndForDate(baseDate, tsValue, offsetMinutes = 2) {
  if (!tsValue) return { start: null, end: null };
  const [hours, minutes] = tsValue.split(":").map(Number);
  const d = baseDate instanceof Date ? baseDate : new Date();
  const endDate = new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate(),
    hours,
    minutes,
    0
  );
  const startDate = new Date(endDate.getTime() - offsetMinutes * 60 * 1000);
  const toLocalString = (x) => x.toLocaleString("sv-SE").replace(" ", "T");
  return { start: toLocalString(startDate), end: toLocalString(endDate) };
}

/* DERIVE LATEST TAGS FROM ROWS */
export const deriveLatestTagsFromRows = (rows) =>
  Array.isArray(rows)
    ? Array.from(
        new Set(
          rows
            .map((r) => r?.tag?.value)
            .filter((v) => typeof v === "string" && v.trim().length > 0)
        )
      )
    : [];

/* DERIVE LATEST TAGS FROM A PDF SETTING (ROWS + BARCHART) */
export const deriveLatestTagsFromPdfSetting = (pdfSetting) => {
  const rows = pdfSetting?.rows;
  const barChart = pdfSetting?.barChart;

  const vals = []
    .concat(Array.isArray(rows) ? rows.map((r) => r?.tag?.value) : [])
    .concat(Array.isArray(barChart) ? barChart.map((b) => b?.value) : [])
    .filter((v) => typeof v === "string" && v.trim().length > 0);

  return Array.from(new Set(vals));
};
